//import { pick } from 'lodash'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  options: {},
  checkProps: {}
}

const getAvailableOptionsActions = generateActions('giftcards/GET')
const getPayActions = generateActions('giftcards/PAY')
const checkActions = generateActions('giftcards/check/GET')

export const getOptions = createAction(
  API_CONST,
  () => ({
    actions: getAvailableOptionsActions,
    url: 'giftcards/availableoptions'
  })
)

export const pay = createAction(
  API_CONST,
  (data = {}) => ({
    actions: getPayActions,
    url: `giftcards/pay`,//  checkout/${id}
    params: { ...data },
    //method: 'POST'
  })
)

export const check = createAction(
  API_CONST,
  ({number, pin}) => ({
    actions: checkActions,
    url: `giftcards/check`,
    params: { number, pin },
  })
)

export default handleActions({
  [getAvailableOptionsActions[0]]: state => ({ ...initial }),
  [getAvailableOptionsActions[1]]: (state, { payload }) => ({
    ...state,
    options: payload
  }),
  [getPayActions[1]]: (state, { payload }) => ({
    ...state,
    checkout: payload
  }),
  [getPayActions[2]]: (state, { payload }) => ({
    ...state,
    init: true
  }),
  [checkActions[0]]: state => ({ ...initial }),
  [checkActions[1]]: (state, { payload }) => ({
    ...state,
    checkProps: payload
  }),
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/giftcards/index.js